export default __webpack_public_path__ + "static/media/family.3a96100a.png";